<template lang="pug">
	.banner-control
		.title {{title}}
		.options-button(v-pseudo-modal-show="this._uid + 'endcard-control-dropdown'")
			i.fa.fa-navicon
		.dropdown-menu.dropdown-menu-right(v-pseudo-modal="this._uid + 'endcard-control-dropdown'")
			.end-cards-table
				.end-card-template(:class="`end-card-template-${endCardIndex}`" v-for="endCardIndex in [0,1,2,3,4,5]" @click="setEndCard(endCardIndex)")

</template>

<script>

    import { Creative } from './../../services/Creative';
    import { Settings } from './../../services/Settings';

    export default {
        name: "EndCardTemplatesList",
        props: ['title'],
        data() {

			this.settings = [
				{
					"end-card": true,
					"end-card-shading-styles": {"backgroundColor": "#131329"},
					"end-card-shading-alpha": 70,
					"end-card-main-button-text": "DOWNLOAD",
					"end-card-main-button-border": false,
					"end-card-main-button-styles": {"display": "inline", "height": 160, "width": 580, "borderRadius": 60, "border": "0px solid #ffffff", "fontSize": 70, "lineHeight": 170, "fontWeight": "bold", "textShadow": "none", "background": "#f53d2e", "boxShadow": "0px 8px 0px 0px #b5232a", "cursor": "pointer", "color": "#ffffff", "textAlign": "center", "marginTop": 50, "marginBottom": 0},
					"end-card-main-button-animation": true,

					"end-card-try-again-button": true,
					"end-card-try-again-button-text": "RETRY",
					"end-card-text-2": true,
					"end-card-text-2-text": "OR",
					"end-card-text-2-styles": {},
					"end-card-try-again-button-border": false,
					"end-card-try-again-button-styles": {"display": "inline", "height": 120, "width": 360, "borderRadius": 50, "border": "0px solid #ffffff", "fontSize": 64, "lineHeight": 130, "fontWeight": "bold", "background": "#ffcd09", "boxShadow": "0px 7px 0px 0px #fdab17", "cursor": "pointer", "color": "#332107", "textAlign": "center", "marginTop": 20, "marginBottom": 0},

					"end-card-bg-lights": false,
					"end-card-bg-lights-styles": {},
					"end-card-bg-lights-animation": false,

					"end-card-text-0": true,
					"end-card-text-0-text": "NICE GAME",
					"end-card-text-0-styles": {"fontSize": 100, "fontWeight": "bold", "textShadow": "0px 0px #ffffff"},
					"end-card-text-1": true,
					"end-card-text-1-text": "#1 Free Game on the App Store",
					"end-card-text-1-styles": {"fontSize": 65},

					"end-card-logo": true,
					"end-card-logo-styles": {"height": 380, "borderRadius": 0, "borderColor": "#2a2d2f", "borderWidth": 1, "transform": "rotate(-1deg)", "marginTop": 0, "marginBottom": 0},

					"end-card-comment": false,
					"end-card-comment-styles": {},
					"end-card-comment-header-text": "REVIEWS",
					"end-card-comment-header-styles": {},
					"end-card-comment-name-styles": {},
					"end-card-comment-text-styles": {},
					"end-card-comment-duration": 5000,
					"end-card-comment-0-name": "Era Ndreu",
					"end-card-comment-0-text": "I really really like it, its fun and helps you to sharpen you brain and the levels get more and more challenging there are ads i just wish they would get rid of that so yeah but i do also wish that you can choose if you want a pizza or fruit or whatever but overall its a great game sure you will get...",
					"end-card-comment-1-name": "Riley Brooker",
					"end-card-comment-1-text": "I love this game! It gets on my nerves a bit though. I highly recommend it to anyone. It is Okay for any ages and it kind of helps young children learn how to mach things to things. It helped me when I was younger to mach things. It has helped me so much do not listen to the people who think it is a...",
					"end-card-comment-2-name": "Sarah Castor",
					"end-card-comment-2-text": "I only just started playing but so far I love it. It's one of those kind of mind numbing games that you can play and not have to think to much about. It's great to play when your exhausted and just looking to do something without a ton of effort."
				},
				{
					"end-card": true,

					"end-card-shading-styles": {"backgroundColor": "#131329"},
					"end-card-shading-alpha": 70,

					"end-card-main-button-text": "Click here to continue!",
					"end-card-main-button-border": false,
					"end-card-main-button-styles": {"display": "inline", "height": 160, "width": 760, "borderRadius": 40, "border": "3px solid #94281d", "fontSize": 58, "lineHeight": 170, "fontWeight": "bold", "background": "#ffffff", "boxShadow": "0px 6px 0px 0px #94281d", "cursor": "pointer", "color": "#d94432", "textAlign": "center", "marginTop": 50, "marginBottom": 0},
					"end-card-main-button-animation": true,

					"end-card-try-again-button": false,
					"end-card-try-again-button-text": "RETRY",
					"end-card-text-2": false,
					"end-card-text-2-text": "OR",
					"end-card-text-2-styles": {},
					"end-card-try-again-button-border": false,
					"end-card-try-again-button-styles": {"display": "inline", "height": 120, "width": 360, "borderRadius": 50, "border": "0px solid #ffffff", "fontSize": 64, "lineHeight": 130, "fontWeight": "bold", "background": "#ffcd09", "boxShadow": "0px 7px 0px 0px #fdab17", "cursor": "pointer", "color": "#332107", "textAlign": "center", "marginTop": 20, "marginBottom": 0},

					"end-card-bg-lights": false,
					"end-card-bg-lights-styles": {},
					"end-card-bg-lights-animation": false,

					"end-card-text-0": true,
					"end-card-text-0-text": "Alright!",
					"end-card-text-0-styles": {"fontSize": 150, "fontWeight": "bold", "textShadow": "3px 3px #94281d"},
					"end-card-text-1": false,
					"end-card-text-1-text": "#1 Free Game on the App Store",
					"end-card-text-1-styles": {},

					"end-card-logo": true,
					"end-card-logo-styles": {"height": 380, "borderRadius": 0, "borderColor": "#2a2d2f", "borderWidth": 1, "transform": "rotate(-1deg)", "marginTop": 0, "marginBottom": 0},

					"end-card-comment": false,
					"end-card-comment-styles": {},
					"end-card-comment-header-text": "REVIEWS",
					"end-card-comment-header-styles": {},
					"end-card-comment-name-styles": {},
					"end-card-comment-text-styles": {},
					"end-card-comment-duration": 5000,
					"end-card-comment-0-name": "",
					"end-card-comment-0-text": "",
					"end-card-comment-1-name": "",
					"end-card-comment-1-text": "",
					"end-card-comment-2-name": "",
					"end-card-comment-2-text": ""
				},
				{
					"end-card": true,

					"end-card-shading-styles": {"backgroundColor": "#131329"},
					"end-card-shading-alpha": 70,

					"end-card-main-button-text": "CONTINUE",
					"end-card-main-button-border": false,
					"end-card-main-button-styles": {"display": "inline", "height": 160, "width": 700, "borderRadius": 60, "border": "0px solid #ffffff", "fontSize": 74, "lineHeight": 170, "fontWeight": "bold", "background": "#ffcd09", "boxShadow": "0px 8px 0px 0px #fdab17", "cursor": "pointer", "color": "#332107", "textAlign": "center", "marginTop": 50, "marginBottom": 0},
					"end-card-main-button-animation": true,

					"end-card-try-again-button": false,
					"end-card-try-again-button-text": "RETRY",
					"end-card-text-2": false,
					"end-card-text-2-text": "OR",
					"end-card-text-2-styles": {},
					"end-card-try-again-button-border": false,
					"end-card-try-again-button-styles": {"display": "inline", "height": 120, "width": 360, "borderRadius": 50, "border": "0px solid #ffffff", "fontSize": 64, "lineHeight": 130, "fontWeight": "bold", "background": "#ffcd09", "boxShadow": "0px 7px 0px 0px #fdab17", "cursor": "pointer", "color": "#332107", "textAlign": "center", "marginTop": 20, "marginBottom": 0},

					"end-card-bg-lights": false,
					"end-card-bg-lights-styles": {},
					"end-card-bg-lights-animation": false,

					"end-card-text-0": true,
					"end-card-text-0-text": "Try Again?",
					"end-card-text-0-styles": {"fontSize": 100, "fontWeight": "bold", "textShadow": "0px 0px #ffffff"},
					"end-card-text-1": false,
					"end-card-text-1-text": "#1 Free Game on the App Store",
					"end-card-text-1-styles": {},

					"end-card-logo": true,
					"end-card-logo-styles": {"height": 380, "borderRadius": 0, "borderColor": "#2a2d2f", "borderWidth": 1, "transform": "rotate(-1deg)", "marginTop": 0, "marginBottom": 0},

					"end-card-comment": false,
					"end-card-comment-styles": {},
					"end-card-comment-header-text": "REVIEWS",
					"end-card-comment-header-styles": {},
					"end-card-comment-name-styles": {},
					"end-card-comment-text-styles": {},
					"end-card-comment-duration": 5000,
					"end-card-comment-0-name": "",
					"end-card-comment-0-text": "",
					"end-card-comment-1-name": "",
					"end-card-comment-1-text": "",
					"end-card-comment-2-name": "",
					"end-card-comment-2-text": ""
				},
				{
					"end-card": true,

					"end-card-shading-styles": {"backgroundColor": "#131329"},
					"end-card-shading-alpha": 90,

					"end-card-main-button-text": "CONTINUE",
					"end-card-main-button-border": false,
					"end-card-main-button-styles": {"display": "inline", "height": 160, "width": 700, "borderRadius": 60, "border": "0px solid #ffffff", "fontSize": 74, "lineHeight": 170, "fontWeight": "bold", "background": "#ccd8ff", "boxShadow": "0px 8px 0px 0px #a2add2", "cursor": "pointer", "color": "#1f2948", "textAlign": "center", "marginTop": 50, "marginBottom": 0},
					"end-card-main-button-animation": true,

					"end-card-try-again-button": false,
					"end-card-try-again-button-text": "RETRY",
					"end-card-text-2": false,
					"end-card-text-2-text": "OR",
					"end-card-text-2-styles": {},
					"end-card-try-again-button-border": false,
					"end-card-try-again-button-styles": {"display": "inline", "height": 120, "width": 360, "borderRadius": 50, "border": "0px solid #ffffff", "fontSize": 64, "lineHeight": 130, "fontWeight": "bold", "background": "#ffcd09", "boxShadow": "0px 7px 0px 0px #fdab17", "cursor": "pointer", "color": "#332107", "textAlign": "center", "marginTop": 20, "marginBottom": 0},

					"end-card-bg-lights": true,
					"end-card-bg-lights-styles": {},
					"end-card-bg-lights-animation": true,

					"end-card-text-0": true,
					"end-card-text-0-text": "Well done!",
					"end-card-text-0-styles": {"fontSize": 100, "fontWeight": "bold", "textShadow": "0px 0px #ffffff"},
					"end-card-text-1": false,
					"end-card-text-1-text": "#1 Free Game on the App Store",
					"end-card-text-1-styles": {},

					"end-card-logo": true,
					"end-card-logo-styles": {"height": 380, "borderRadius": 0, "borderColor": "#2a2d2f", "borderWidth": 1, "transform": "rotate(-1deg)", "marginTop": 0, "marginBottom": 0},

					"end-card-comment": false,
					"end-card-comment-styles": {},
					"end-card-comment-header-text": "REVIEWS",
					"end-card-comment-header-styles": {},
					"end-card-comment-name-styles": {},
					"end-card-comment-text-styles": {},
					"end-card-comment-duration": 5000,
					"end-card-comment-0-name": "",
					"end-card-comment-0-text": "",
					"end-card-comment-1-name": "",
					"end-card-comment-1-text": "",
					"end-card-comment-2-name": "",
					"end-card-comment-2-text": ""
				},
				{
					"end-card": true,
					"end-card-shading-styles": {"backgroundColor": "#131329"},
					"end-card-shading-alpha": 70,
					"end-card-main-button-text": "DOWNLOAD",
					"end-card-main-button-border": false,
					"end-card-main-button-styles": {"display": "inline", "height": 160, "width": 580, "borderRadius": 60, "border": "0px solid #ffffff", "fontSize": 70, "lineHeight": 170, "fontWeight": "bold", "background": "#f53d2e", "boxShadow": "0px 8px 0px 0px #b5232a", "cursor": "pointer", "color": "#ffffff", "textAlign": "center", "marginTop": 50, "marginBottom": 0},
					"end-card-main-button-animation": true,

					"end-card-try-again-button": false,
					"end-card-try-again-button-text": "RETRY",
					"end-card-text-2": false,
					"end-card-text-2-text": "OR",
					"end-card-text-2-styles": {},
					"end-card-try-again-button-border": false,
					"end-card-try-again-button-styles": {"display": "inline", "height": 120, "width": 360, "borderRadius": 50, "border": "0px solid #ffffff", "fontSize": 64, "lineHeight": 130, "fontWeight": "bold", "background": "#ffcd09", "boxShadow": "0px 7px 0px 0px #fdab17", "cursor": "pointer", "color": "#332107", "textAlign": "center", "marginTop": 20, "marginBottom": 0},

					"end-card-bg-lights": false,
					"end-card-bg-lights-styles": {},
					"end-card-bg-lights-animation": false,

					"end-card-text-0": false,
					"end-card-text-0-text": "NICE GAME",
					"end-card-text-0-styles": {"fontSize": 100, "fontWeight": "bold", "textShadow": "0px 0px #ffffff"},
					"end-card-text-1": false,
					"end-card-text-1-text": "#1 Free Game on the App Store",
					"end-card-text-1-styles": {"fontSize": 65},

					"end-card-logo": true,
					"end-card-logo-styles": {"height": 380, "borderRadius": 0, "borderColor": "#2a2d2f", "borderWidth": 1, "transform": "rotate(-1deg)", "marginTop": 0, "marginBottom": 0},

					"end-card-comment": true,
					"end-card-comment-styles": {},
					"end-card-comment-header-text": "REVIEWS",
					"end-card-comment-header-styles": {},
					"end-card-comment-name-styles": {},
					"end-card-comment-text-styles": {},
					"end-card-comment-duration": 5000,
					"end-card-comment-0-name": "Era Ndreu",
					"end-card-comment-0-text": "I really really like it, its fun and helps you to sharpen you brain and the levels get more and more challenging there are ads i just wish they would get rid of that so yeah but i do also wish that you can choose if you want a pizza or fruit or whatever but overall its a great game sure you will get...",
					"end-card-comment-1-name": "Riley Brooker",
					"end-card-comment-1-text": "I love this game! It gets on my nerves a bit though. I highly recommend it to anyone. It is Okay for any ages and it kind of helps young children learn how to mach things to things. It helped me when I was younger to mach things. It has helped me so much do not listen to the people who think it is a...",
					"end-card-comment-2-name": "Sarah Castor",
					"end-card-comment-2-text": "I only just started playing but so far I love it. It's one of those kind of mind numbing games that you can play and not have to think to much about. It's great to play when your exhausted and just looking to do something without a ton of effort."
				},
				{
					"end-card": true,
					"end-card-shading-styles": {"backgroundColor": "#131329"},
					"end-card-shading-alpha": 70,
					"end-card-main-button-text": "DOWNLOAD!",
					"end-card-main-button-border": true,
					"end-card-main-button-border-styles": {"padding": "2px", "borderRadius": 100, "background": "linear-gradient(to top, #528af8, #b5d4e8)", "boxShadow": "rgb(0 0 0 / 30%) 0px 5px 4px 0px", "cursor": "pointer", "marginTop": 50, "marginBottom": 0},
					"end-card-main-button-styles": {"display": "flex", "justifyContent": "center", "alignItems": "center", "height": 160, "width": 580, "borderRadius": "inherit", "color": "#ffffff", "fontSize": 70, "fontWeight": "bold", "textShadow": "3px 3px 3px hsl(0deg 0% 0% / 50%)", "textAlign": "center", "background": "linear-gradient(to right, #73abfb, #86ecfd)", "backgroundColor": "none", "boxShadow": "none", "border": "none", "lineHeight": "unset", "marginTop": 0, "marginBottom": 0},
					"end-card-main-button-animation": true,

					"end-card-try-again-button": true,
					"end-card-try-again-button-text": "Retry",
					"end-card-text-2": false,
					"end-card-text-2-text": "OR",
					"end-card-text-2-styles": {},
					"end-card-try-again-button-border": true,
					"end-card-try-again-button-border-styles": {"padding": "2px", "borderRadius": 100, "background": "linear-gradient(to top, #528af8, #b5d4e8)", "boxShadow": "rgb(0 0 0 / 30%) 0px 5px 4px 0px", "cursor": "pointer", "marginTop": 50, "marginBottom": 0},
					"end-card-try-again-button-styles": {"display": "flex", "justifyContent": "center", "alignItems": "center", "height": 120, "width": 360, "borderRadius": "inherit", "color": "#ffffff", "fontSize": 70, "fontWeight": "bold", "textShadow": "3px 3px 3px hsl(0deg 0% 0% / 50%)", "textAlign": "center", "background": "linear-gradient(to right, #73abfb, #86ecfd)", "backgroundColor": "none", "boxShadow": "none", "border": "none", "lineHeight": "unset", "marginTop": 0, "marginBottom": 0},

					"end-card-bg-lights": false,
					"end-card-bg-lights-styles": {},
					"end-card-bg-lights-animation": false,

					"end-card-text-0": true,
					"end-card-text-0-text": "Game Name",
					"end-card-text-0-styles": {"fontSize": 100, "fontWeight": "bold", "textShadow": "0px 0px #ffffff"},
					"end-card-text-1": false,
					"end-card-text-1-text": "#1 Free Game on the App Store",
					"end-card-text-1-styles": {"fontSize": 65},

					"end-card-logo": true,
					"end-card-logo-styles": {"height": 460, "borderRadius": 34, "borderColor": "#2a2d2f", "borderWidth": 1, "transform": "rotate(0deg)", "marginTop": 0, "marginBottom": 0},

					"end-card-comment": false,
					"end-card-comment-styles": {},
					"end-card-comment-header-text": "REVIEWS",
					"end-card-comment-header-styles": {},
					"end-card-comment-name-styles": {},
					"end-card-comment-text-styles": {},
					"end-card-comment-duration": 5000,
					"end-card-comment-0-name": "Era Ndreu",
					"end-card-comment-0-text": "I really really like it, its fun and helps you to sharpen you brain and the levels get more and more challenging there are ads i just wish they would get rid of that so yeah but i do also wish that you can choose if you want a pizza or fruit or whatever but overall its a great game sure you will get...",
					"end-card-comment-1-name": "Riley Brooker",
					"end-card-comment-1-text": "I love this game! It gets on my nerves a bit though. I highly recommend it to anyone. It is Okay for any ages and it kind of helps young children learn how to mach things to things. It helped me when I was younger to mach things. It has helped me so much do not listen to the people who think it is a...",
					"end-card-comment-2-name": "Sarah Castor",
					"end-card-comment-2-text": "I only just started playing but so far I love it. It's one of those kind of mind numbing games that you can play and not have to think to much about. It's great to play when your exhausted and just looking to do something without a ton of effort."
				}
			];

            return {

            };

        },
        methods: {
            setEndCard(id) {

                Broadcast.call("Pseudo Modal Hide", [this._uid + 'endcard-control-dropdown']);

                const prefix = this.prefix;

                for (let key in this.settings[id]) {

                    if (!this.settings[id].hasOwnProperty(key)) continue;

                    //TODO: нельзя делать это в цикле - нужно предусмотреть отправку на сервер сразу нескольких настроек
                    Settings.setSettingValue(key, this.settings[id][key]);

                }

                Broadcast.call("Update Settings Content", []);

            }
        }
    }
</script>


<style lang="sass">

	.banner-control
		position: relative
		font-size: 0.875rem

	.options-button
		padding: 1rem 0 0 0
		cursor: pointer
		position: absolute
		right: 0px
		top: -20px
		font-size: 0.875rem

	.dropdown-menu
		right: 0px
		top: 20px
		box-shadow: 0 0 10px rgba(0, 0, 0, 0.5)

	.end-card-template
		width: 48%
		height: 169px
		background-size: contain
		background-repeat: no-repeat
		background-position: center center
		cursor: pointer
		transition: 0.2s
		margin: 1%
		&:hover
			opacity: 0.8

	.end-card-template-0
		background-image: url("./../../assets/end-card-template-0.png")

	.end-card-template-1
		background-image: url("./../../assets/end-card-template-1.png")

	.end-card-template-2
		background-image: url("./../../assets/end-card-template-2.png")

	.end-card-template-3
		background-image: url("./../../assets/end-card-template-3.png")

	.end-card-template-4
		background-image: url("./../../assets/end-card-template-4.png")

	.end-card-template-5
		background-image: url("./../../assets/end-card-template-5.png")

	.end-cards-table
		display: flex
		flex-wrap: wrap

</style>

